import { render, staticRenderFns } from "./InspectionsSettings.vue?vue&type=template&id=35abc252&"
import script from "./InspectionsSettings.vue?vue&type=script&lang=js&"
export * from "./InspectionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports